import React from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export const truncMid = (s, head = 8, tail = 6) => {
  if (!s) return "";
  if (s.length <= head + tail + 3) return s;
  return `${s.slice(0, head)}…${s.slice(-tail)}`;
};

export default function HashString({ value, mono = true, label, className = "", testid }) {
  const onCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label || "Copied"} to clipboard`, { description: truncMid(value, 14, 10) });
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <span
      className={`hash-pill group inline-flex items-center gap-1 align-middle ${
        mono ? "font-mono" : ""
      } ${className}`}
      onClick={onCopy}
      title={value}
      data-testid={testid}
    >
      <span className="truncate">{truncMid(value)}</span>
      <Copy className="w-3 h-3 opacity-40 group-hover:opacity-100 transition-opacity shrink-0" strokeWidth={1.5} />
    </span>
  );
}
